import React from 'react';
import { Box, Chip, Tooltip } from '@mui/material';
import { providerStatusChips } from '../utils/providerStatus';

/** Tone -> MUI. Kept in one place so the meaning of a colour cannot drift between pages. */
const TONE = {
  grey: { color: 'default', variant: 'outlined' },
  amber: { color: 'warning', variant: 'filled' },
  green: { color: 'success', variant: 'outlined' },
  red: { color: 'error', variant: 'filled' },
};

const ProviderStatusChips = ({ provider }) => {
  if (!provider) return null;

  return (
    <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
      {providerStatusChips(provider).map((chip) => {
        const node = (
          <Chip key={chip.label} label={chip.label} size="small" {...TONE[chip.tone]} />
        );
        return chip.title
          ? <Tooltip key={chip.label} title={chip.title}>{node}</Tooltip>
          : node;
      })}
    </Box>
  );
};

export default ProviderStatusChips;
